import "./App.css";
import TaskManager from "./components/taskManager/TaskManager";

function App() {
  return (
    <div>
      <TaskManager />
    </div>
  );
}

export default App;
